import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import { api } from "../../api";
import { useSelector } from "react-redux";

const ViewProfile = props => {

    const token = useSelector((state) => state.auth.token);
    const { userType: role } = useSelector((state) => state.auth.user);


    const [userData, setUserData] = useState({
        usersUserName: "",
        usersName: "",
        usersPhone: "",
        usersEmail: "",
        usersUserType: "",
        usersBrand: "",
        usersAgentType: ""
    })

    useEffect(() => {
        api.users.getProfile({}, token)
            .then(res => {
            
                    const user = res || {};
                    console.log('api response received');
                    console.log(user);
    
                    setUserData({
                        usersUserName: user.userName || "",
                        usersName: user.name || "",
                        usersPhone: user.phone || "",
                        usersEmail: user.email || "",
                        usersUserType: user.userType || "",
                        usersBrand: "",
                        usersAgentType: ""
                    });
               
            })
            .catch(err => console.log(err, ' errr'));
    }, [token]);

    const { usersName, usersPhone, usersEmail, usersUserType } = userData

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-sm-12">
                    <div className="box-row">
                        <div className="table-head">
                            <h1 className="sec-header">PROFILE DETAILS</h1>
                        </div>
                        <div className="card">
                            <div className="card-body box-row">

                                {/* <h1 className="section-header float-left">Profile Details</h1> */}

                                <div style={{ position: 'absolute', top: '0px', right: '15px' }}>
                                    <Link to="/profile-settings">
                                        <button className="btn mt-3 submit-btn" variant="primary" type="submit"> Edit </button>
                                    </Link>
                                </div>

                                <div className="reports">
                                    <div className="form-row col-md-6">
                                        <div className="form-group col-md-10" style={{ margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                            <p style={{ width: '25%' }}><b>Agent Name</b></p>
                                            <p style={{ width: '10%' }}> : </p>
                                            <p style={{ width: '55%' }}>{usersName}</p>
                                        </div>
                                    </div>
                                    <div className="form-row col-md-6">
                                        <div className="form-group col-md-10" style={{ margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                            <p style={{ width: '25%' }}><b>Phone</b></p>
                                            <p style={{ width: '10%' }}> : </p>
                                            <p style={{ width: '55%' }}>{usersPhone}</p>
                                        </div>
                                    </div>
                                    <div className="form-row col-md-6">
                                        <div className="form-group col-md-10" style={{ margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                            <p style={{ width: '25%' }}><b>Email</b></p>
                                            <p style={{ width: '10%' }}> : </p>
                                            <p style={{ width: '55%' }}>{usersEmail}</p>
                                        </div>
                                    </div>
                                    <div className="form-row col-md-6">
                                        <div className="form-group col-md-10" style={{ margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                            <p style={{ width: '25%' }}><b>User Type</b></p>
                                            <p style={{ width: '10%' }}> : </p>
                                            <p style={{ width: '55%' }}>{usersUserType === "1" ? "Super Admin" : usersUserType === "2" ? "Admin" : usersUserType === "3" ? "Merchant" : usersUserType === "4" ? "Customer Support" : ""}</p>
                                        </div>
                                    </div>

                                </div>

                                {/* <div style={{ margin: '0px 50px' }}>
                                    <div className="form-group row col-md-8">
                                        <div className="col-md-3"><span><b>Agent Name</b>{' '}:</span></div>
                                        <div className="col-md-5"><span>{usersName}</span></div>
                                    </div>

                                    <div className="form-group row col-md-8">
                                        <div className="col-md-3"><span><b>Phone</b>{' '}:</span></div>
                                        <div className="col-md-5"><span>{usersPhone}</span></div>
                                    </div>

                                    <div className="form-group row col-md-8">
                                        <div className="col-md-3"><span><b>Email</b>{' '}:</span></div>
                                        <div className="col-md-5"><span>{usersEmail}</span></div>
                                    </div>
                                    
                                    <div className="form-group row col-md-8">
                                        <div className="col-md-3"><span><b>User Type</b>{' '}:</span></div>
                                        <div className="col-md-5"><span>{usersUserType == "1" ? "Super Admin" : usersUserType == "2" ? "Admin" : usersUserType == "3" ? "Merchant" : usersUserType == "4" ? "Customer Support" : "" }</span></div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="form-row col-md-12" style={{ marginTop: '20px'}}>
                        {role === 3 && (
                        <>
                        <Link to={`/view-merchant-agreement`} style={{ color:'blue' }}>RESELLER AGREEMENT TERMS AND CONDITIONS</Link>
                        </>
                        )}  
                        </div>

                    </div>
                </div>
            </div>
        </div >
    );
}

export default ViewProfile;